(function($) {
  
  $(document).foundation();
  
  // Slick config
  
    /* CABEÇALHO */
      
    $('.mobile-button .container').on('click', function () {
      
      $('.menu-links').toggleClass('show-menu');
      $('html').toggleClass('no-scroll');
      
      let $count = 1;
      let $tempo = 30;
      
      $('.menu-item-has-children').each(function() {
        let $this = $(this)
        
        $this.removeClass('submenu-visible')
      })
      
      $('.menu-links a').each(function () {
          let $this = $(this);
          
          setTimeout(function () {
              $this.toggleClass('show-link');
          }, ($this.hasClass('show-link')?0:1)*$tempo*$count++);
    });
      
    setTimeout(function () {
        $('.copyright').toggleClass('show-copy');
    }, ($('.copyright').hasClass('show-copy')?0:1.5)*($tempo)*$count++);
    
    });
    
    $('#scroll-top').on('click', function () {
        window.scrollTo({top: 0, behavior: 'smooth'});
    });
    
    /* MENU - CLIENTES */
    
    $('.clientes .category').on('click', function() {
      $('.subcategories-container').removeClass('visible');
      $('.clientes .category').removeClass('selected');
      
      $(this).addClass('selected');
      
      if ($(this).hasClass('residential')) {
        $('.subcategories-container.residential').addClass('visible');
      }
      
      if ($(this).hasClass('business')) {
        $('.subcategories-container.business').addClass('visible');
      }
      
      if ($(this).hasClass('factory')) {
        $('.subcategories-container.factory').addClass('visible');
      }
      
      if ($(this).hasClass('warm')) {
        $('.subcategories-container.warm').addClass('visible');
      }
    });
    
    
    /* CLIENTES DESTAQUE SLIDER */
    
    const profissionais = $('.clients-photos .clientes-destaque');
  	
  	if (profissionais.length) {
  			
  		profissionais.each(function() {
  			const container = $(this)
  			const slider = container.find('.slider-wrapper')
  			const prevArrow = container.find('.prev')
  			const nextArrow = container.find('.next')
  			
  			slider.slick({
  				slidesToShow: 3,
  				slidesToScroll: 1,
  				infinite: true,
  				dots: false,
  				arrows: true,
  				prevArrow: prevArrow,
  				nextArrow: nextArrow,
  				responsive: [
  					{
  						breakpoint: 993,
  						settings: {
  							slidesToShow: 2,
  							slidesToScroll: 1,
  							dots: false,
  						}
  					},
  					{
  						breakpoint: 576,
  						settings: {
  							slidesToShow: 1,
  							slidesToScroll: 1,
  							arrows: true,
  							dots: false,
  							appendDots: container
  						}
  					}
  				]
  			})
  		})
  	}
  	
  	
  	
    
    /* NOSSA HISTÓRIA - objectives animation */
    
    
    if ($('.objectives').length) {
      $(window).scroll(function() {
        let pos = $('.objectives').offset().top - $(window).height() - 250;
        
        if($(window).scrollTop() > pos) {
          if (!($('.objectives .objective')).hasClass('show')) {
            let $count = 0;
            
            $('.objectives .objective').each(function () {
              let $this = $(this);
              
              setTimeout(function () {
                if (!($this.hasClass('show'))) {
                  $($this).addClass('show');
                }
              }, 500*$count++);
            });
          }
        }
          
      });
    }
    
    /* ENERGIA SOLAR - steps animation */
    
    if ($('.solar-energy-how-works-content-2-table').length) {
      
      if (!($('.solar-energy-how-works-content-2-table').hasClass('show-options'))) {
        
        $(window).scroll(function() {
          let pos = $('.solar-energy-how-works-content-2-table').offset().top - $(window).height() - 250;
          
          if($(window).scrollTop() > pos) {
            
            $('.solar-energy-how-works-content-2-table').addClass('show-options');
            
            if (!($('.data-step')).hasClass('show')) {
              let $count = 0;
              
              setTimeout(function () {
                $('.solar-energy-how-works-content-2-data').each(function () {
                  let $this = $(this);
                  
                  setTimeout(function () {
                    if ($this.hasClass('data-step')) {
                      if (!($this.hasClass('show-step'))) {
                        $($this).addClass('show-step');
                      }
                    }
                    
                    if ($this.hasClass('data-faq')) {
                      if (!($this.hasClass('show-faq'))) {
                        $($this).addClass('show-faq');
                      }
                    }
                  }, 700*$count++);
                  
                });
              }, 400);
            }
          }
        });
        
      }
    
    }
    
    /* INDICAÇÃO - agree rules */
    
    if ($('.rules').length) {
      $('.button-agree').on('click', function() {
        $('.indicacao-form').addClass('show');
        $('.dropdown-arrow').addClass('rotate');
      });
    }
    
    
    /* INTERNET - APARECER UMA OPÇÃO DO PLANO DE CADA VEZ */
    
    
   
    
    $(window).scroll(function() {
      if ($('.radio-plan').length) {
      
        if (!($('.radio-plan').hasClass('show-options'))) {
        
          let pos = $('.radio-plan').offset().top - 300;
          
          if($(window).scrollTop() > pos) {
          
            $('.radio-plan').addClass('show-options');
            let $count1 = 0;
            
            $('.radio-plan .internet-plan-option').each(function () {
            
              let $plan = $(this);
              
              setTimeout(function () {
                let $count2 = 0;
                
                $($plan).find('.internet-plan-option-resource-container').each(function () {
                  let $option = $(this);
                  
                  
                  setTimeout(function () {
                    $option.addClass('show');
                  }, 200*$count2++);
                
                });
              }, 0*$count1++);
            });
          }
        }
      }
    });
    
    $(window).scroll(function() {
      if ($('.fiber-plan').length) {
      
        if (!($('.fiber-plan').hasClass('show-options'))) {
          let pos = $('.fiber-plan').offset().top - 300;
          if($(window).scrollTop() > pos) {
          
            $('.fiber-plan').addClass('show-options');
            let $count1 = 0;
            
            $('.fiber-plan .internet-plan-option').each(function () {
            
              let $plan = $(this);
              
              setTimeout(function () {
                let $count2 = 0;
                
                $($plan).find('.internet-plan-option-resource-container').each(function () {
                  let $option = $(this);
                  
                  setTimeout(function () {
                    $option.addClass('show');
                  }, 200*$count2++);
                
                });
              }, 0*$count1++);
            });
          
          }
        }
      }
    });
    
    
    /* ENERGIA SOLAR - Alterar números gradativamente nas informações */
    
    var infos = [];
  
    if ($('.solar-energy-infos-container').length) {
      $('.energy-value').each(function () {
          infos.push($(this).html());
      });
      
      $('.energy-value').each(function () {
          $(this).html('0');
      });
    }
    
    $(window).scroll(function() {
      if ($('.solar-energy-infos-container').length) {
        if (!$('.solar-energy-infos-container').hasClass('show-values')) {
          let pos = $('.solar-energy-infos-container').offset().top - $(window).height() + 300;

          if ($(window).scrollTop() > pos) {
            $('.solar-energy-infos-container').addClass('show-values');
            $('.solar-energy-infos-item-container').each(function(index) {
              let $info = $(this);
              let $numeroFinal = infos[index];
              let $passo = $numeroFinal / 2500;

              for (let $numeroAtual = 0; $numeroAtual <= $numeroFinal; $numeroAtual += $passo) {
                let $valorAtual = $numeroAtual;
                setTimeout(function() {
                  $info.find('.energy-value').html(parseFloat($valorAtual.toFixed(1)));
                }, $valorAtual / $passo);
              }

              console.log($numeroFinal);
              console.log($passo);

              setTimeout(function() {
                $info.find('.energy-value').html($numeroFinal);
              }, ($numeroFinal / $passo) + $passo);
            });
          }
        }
      }
    });

        
    /* ENERGIA SOLAR - Parallax nas nuvens */
    
    if ($('.solar-energy-infos-nuvem').length) {
      $distancia = $(window).scrollTop();
      $('.solar-energy-infos-nuvem').css(`transform`,`translateY(${$distancia * 0.3 - 300}px)`)
    }
    
    $(window).scroll(function() {
      if ($('.solar-energy-infos-nuvem').length) {
        $distancia = $(window).scrollTop();
        $('.solar-energy-infos-nuvem').css(`transform`,`translateY(${$distancia * 0.3 - 300}px)`);
      }
    });
    
    
    
    
    
    /* Submenu */
    const menu = document.querySelector('.menu-links > .menu')
    
    if(menu) {
      const submenuLinks = menu.querySelectorAll('.menu-item-has-children > a')
      
      submenuLinks.forEach(item => {
        item.addEventListener('click', function(event) {
          const currentTarget = event.currentTarget
          
          if(currentTarget.getAttribute('href') === '#') {
            event.preventDefault()
          }
          
          const parent = currentTarget.closest('.menu-item-has-children')
          
          parent.classList.contains('submenu-visible')
            ? parent.classList.remove('submenu-visible')
            : parent.classList.add('submenu-visible')
        })
      })
    }
    
})(jQuery);